import * as ko from 'knockout';
import { Uppy, debugLogger } from '@uppy/core';
import Dashboard from '@uppy/dashboard';
import Tus from '@uppy/tus';
import XHRUpload from '@uppy/xhr-upload';
import Dropbox from '@uppy/dropbox';
import OneDrive from '@uppy/onedrive';
import GoogleDrive from '@uppy/google-drive';
const filenamify = require('filenamify');
const path = require('path');

import { addNotification } from './../notifications';
import { makeid } from './../utils.js';

let tus_endpoint = tus_upload_url;
let companionUrl = 'https://' + window.location.host + '/companion';

ko.bindingHandlers.fileUploader =
{
    init: function(element, valueAccessor, allBindings, viewModel, bindingContext)
    {
        var uploadModel = viewModel;
        var element_id = uploadModel.element_id;
        var parent_id = null;

        if( typeof uploadModel.parent_id() !== 'undefined' )
            parent_id = uploadModel.parent_id();

        let fileUploader;

        fileUploader = new Uppy({
            logger: debugLogger,
            id: element_id,
            autoProceed: (parent_id !== null), // auto start upload when there is a parent_id
            allowMultipleUploadBatches: false,
            debug: true,
            restrictions: {
                maxFileSize: null,
                minFileSize: null,
                maxTotalFileSize: null,
                maxNumberOfFiles: 1,
                minNumberOfFiles: null,
                allowedFileTypes: uploadModel.acceptedFileTypes
            },
            meta: {
                content_type: uploadModel.upload_type,
                parent_id: parent_id,
            },
            onBeforeFileAdded: (currentFile, files) => {

                let filename_clean = currentFile.name.replaceAll("&", "").replaceAll(":", "").replaceAll("#", "").replaceAll("'", "").replaceAll('"', '').replaceAll('@', '').replaceAll('?', '').replaceAll('!', '').replaceAll('$', '').replaceAll('%', '');
                let file_extension = path.extname(filename_clean);

                // Create a safe filename
                let filename_safe = filenamify(filename_clean, {replacement: '', maxLength: 300});

                // Remove file extension from filename
                let basename = path.basename(filename_safe, file_extension);
                
                // Add unique ID to each filename
                let filename_unique = basename + '-' + makeid(7) + file_extension;

                if( uploadModel.upload_type === 'mix_unknown' && [".mp4", ".m4v", ".mov", ".m4p", ".mpg", ".mpeg", ".mp2", ".mpv"].includes(file_extension) )
                    uploadModel.upload_type = 'mix_video';
                else if( uploadModel.upload_type === 'mix_unknown' && [".mp3", ".wav", ".aac"].includes(file_extension) )
                    uploadModel.upload_type = 'mix_audio';

                const modifiedFile = {
                    ...currentFile,
                    name: filename_unique,
                    meta: {
                        ...currentFile.meta,
                        name: filename_unique,
                        filename_orig: currentFile.name,
                        uuid: uploadModel.uuid(),
                        client_key: client_key,
                        client_id: client_id,
                        content_type: uploadModel.upload_type,
                    }
                };

                if( !parent_id && typeof uploadModel.generate_parent_id === 'function' )
                {
                    uploadModel.generate_parent_id().then(function(data) 
                    {
                        parent_id = data.result;

                        fileUploader.setMeta({ 
                            parent_id: parent_id, 
                            id: parent_id, 
                            name: filename_unique, 
                            filename_orig: currentFile.name, 
                            uuid: uploadModel.uuid(),
                            client_key: client_key,
                            client_id: client_id,
                        });

                        modifiedFile.meta.parent_id = parent_id;
                        modifiedFile.meta.id = parent_id;

                        fileUploader.upload();

                        return modifiedFile;
                    });
                }
                else
                {   
                    return modifiedFile;
                }
            },
            infoTimeout: 5000
        });

        if( uploadModel.constructor.name === 'UploadButton' ) 
        {
            fileUploader.setMeta({ 
                id: parent_id, 
                action: 'upload_' + uploadModel.upload_type,
            });

            fileUploader.use(XHRUpload, {
                endpoint: ajax_url,
                formData: true,
                fieldName: uploadModel.upload_type,
                allowedMetaFields: ['id', 'action'],
                bundle: true,
                getResponseError (responseText, response) {
                    console.log(responseText, response);
                    return new Error(JSON.parse(responseText).message);
                },
            });

            fileUploader.use(Dashboard, {
                id: 'Dashboard',
                trigger: '#select_files_' + element_id,
                showLinkToFileUploadResult: true,
                showProgressDetails: false,
                hideUploadButton: false,
                hideRetryButton: false,
                hidePauseResumeButton: false,
                hideCancelButton: false,
                hideProgressAfterFinish: false,
                doneButtonHandler: () => {
                    fileUploader.cancelAll();
                },
                note: null,
                closeModalOnClickOutside: false,
                closeAfterFinish: false,
                disableStatusBar: false,
                disableInformer: false,
                disableThumbnailGenerator: true,
                disablePageScrollWhenModalOpen: true,
                animateOpenClose: true,
                fileManagerSelectionType: 'files',
                proudlyDisplayPoweredByUppy: false,
                showSelectedFiles: false,
                showRemoveButtonAfterComplete: false,
                browserBackButtonClose: false,
                theme: 'light',
                autoOpenFileEditor: false,
                locale: {
                    strings: {
                        browseFiles: 'browse file',
                        dropPasteBoth: 'Drop file here, paste, %{browseFiles} or %{browseFolders}',
                        dropPasteFiles: 'Drop file here, paste or %{browseFiles}',
                        dropPasteFolders: 'Drop file here, paste or %{browseFolders}',
                        dropPasteImportBoth: 'Drop file here, paste, %{browseFiles}, %{browseFolders} or import from:',
                        dropPasteImportFiles: 'Drop file here, paste, %{browseFiles} or import from:',
                        dropPasteImportFolders: 'Drop file here, paste, %{browseFolders} or import from:',
                    }
                }
            });
        }
        else if( uploadModel.constructor.name === 'UploadArea' ) 
        {
            fileUploader.use(Tus, { 
                endpoint: tus_endpoint,
                limit: 4,
                chunkSize: 5 * 1024 * 1024, // 5 MB
                retryDelays: [0, 1000, 3000, 5000],
            });

            fileUploader.use(Dashboard, {
                id: 'Dashboard',
                target: '#' + element_id,
                metaFields: [],
                inline: true,
                width: '100%',
                height: 450,
                showLinkToFileUploadResult: true,
                showProgressDetails: false,
                hideUploadButton: false,
                hideRetryButton: false,
                hidePauseResumeButton: false,
                hideCancelButton: false,
                hideProgressAfterFinish: false,
                doneButtonHandler: () => {
                    fileUploader.cancelAll();
                },
                note: null,
                closeModalOnClickOutside: false,
                closeAfterFinish: false,
                disableStatusBar: false,
                disableInformer: false,
                disableThumbnailGenerator: true,
                disablePageScrollWhenModalOpen: true,
                animateOpenClose: true,
                fileManagerSelectionType: 'files',
                proudlyDisplayPoweredByUppy: false,
                onRequestCloseModal: () => this.closeModal(),
                showSelectedFiles: false,
                showRemoveButtonAfterComplete: false,
                browserBackButtonClose: false,
                theme: 'light',
                autoOpenFileEditor: false,
                locale: {
                    strings: {
                        browseFiles: 'browse file',
                        dropPasteBoth: 'Drop file here, paste, %{browseFiles} or %{browseFolders}',
                        dropPasteFiles: 'Drop file here, paste or %{browseFiles}',
                        dropPasteFolders: 'Drop file here, paste or %{browseFolders}',
                        dropPasteImportBoth: 'Drop file here, paste, %{browseFiles}, %{browseFolders} or import from:',
                        dropPasteImportFiles: 'Drop file here, paste, %{browseFiles} or import from:',
                        dropPasteImportFolders: 'Drop file here, paste, %{browseFolders} or import from:',
                    }
                }
            });

            fileUploader.use(Dropbox, {
                target: Dashboard,
                companionUrl: companionUrl,
            });

            fileUploader.use(OneDrive, {
                target: Dashboard,
                companionUrl: companionUrl,
            });

            // fileUploader.use(GoogleDrive, {
            //     target: Dashboard,
            //     companionUrl: companionUrl,
            // });
        }
        
        fileUploader.on('upload-progress', (file, progress) => 
        {
            if( uploadModel.upload_type === 'track_audio' || uploadModel.upload_type === 'track_video' || uploadModel.upload_type === 'track_background_video' || uploadModel.upload_type === 'asset_video' || uploadModel.upload_type === 'mix_audio' || uploadModel.upload_type === 'mix_background_video_loop' || uploadModel.upload_type === 'mix_video' || uploadModel.upload_type === 'playlist_background_video_loop' )
            {
                if( file.meta.uuid === uploadModel.uuid() )
                {
                    var percentage = Math.floor(progress.bytesUploaded / progress.bytesTotal * 100);
                    uploadModel.upload_progress( percentage);

                    if( percentage > 0 ) 
                    {
                        if( uploadModel.upload_status() !== 'uploading-paused' )
                            uploadModel.upload_status('uploading');
                    }
                    else
                        uploadModel.upload_status('init');
                }
            }
        });

        // Fired each time a single upload is completed.
        fileUploader.on('upload-success', (file, response) => 
        {
            for (var i = 0; i < localStorage.length; i++)
            {                
                if( localStorage.key(i).includes(file.id) )
                    localStorage.removeItem( localStorage.key(i) );
            }

            if( response.uploadURL )
            {
                if( uploadModel.uuid() !== undefined && uploadModel.uuid() === file.meta.uuid ) 
                {
                    var parts = response.uploadURL.split("/");
                    var uploadKey = parts[parts.length - 1];

                    uploadModel.uploadKey(uploadKey);
                }
            }

            if( response.body )
            {
                if( uploadModel.upload_type === 'track_coverart' )
                {
                    uploadModel.file_url(response.body.track_coverart[0].url);
                    uploadModel.file_second_url(response.body.track_coverart[0].background_image);
                    fileUploader.cancelAll();
                    addNotification( 'Coverart uploaded', 'success' );

                    const dashboard = fileUploader.getPlugin('Dashboard')
                    
                    if ( dashboard.isModalOpen() )
                        dashboard.closeModal();
                }
                else if( uploadModel.upload_type === 'track_background_image' )
                {
                    uploadModel.file_url(response.body.track_background_image[0].url);
                    fileUploader.cancelAll();
                    addNotification( 'Background uploaded', 'success' );

                    const dashboard = fileUploader.getPlugin('Dashboard')
                    
                    if ( dashboard.isModalOpen() )
                        dashboard.closeModal();
                }
                else if( uploadModel.upload_type === 'artist_image' )
                {
                    uploadModel.file_url(response.body.artist_image[0].url);
                    fileUploader.cancelAll();
                    addNotification( 'Artist image is uploaded', 'success' );

                    const dashboard = fileUploader.getPlugin('Dashboard')
                    
                    if ( dashboard.isModalOpen() )
                        dashboard.closeModal();
                }
                else if( uploadModel.upload_type === 'mix_coverart' )
                {
                    uploadModel.file_url(response.body.mix_coverart[0].coverart);
                    fileUploader.cancelAll();
                    addNotification( 'Coverart uploaded', 'success' );

                    const dashboard = fileUploader.getPlugin('Dashboard')
                    
                    if ( dashboard.isModalOpen() )
                        dashboard.closeModal();
                }
                else if( uploadModel.upload_type === 'mix_background_image' )
                {
                    uploadModel.file_url(response.body.mix_background_image[0].background_image);
                    fileUploader.cancelAll();
                    addNotification( 'Background image uploaded', 'success' );

                    const dashboard = fileUploader.getPlugin('Dashboard')
                    
                    if ( dashboard.isModalOpen() )
                        dashboard.closeModal();
                }
                else if( uploadModel.upload_type === 'playlist_background_image' )
                {
                    uploadModel.file_url(response.body.playlist_background_image[0].background_image);
                    fileUploader.cancelAll();
                    addNotification( 'Background image uploaded', 'success' );

                    const dashboard = fileUploader.getPlugin('Dashboard')
                    
                    if ( dashboard.isModalOpen() )
                        dashboard.closeModal();
                }
                else if( uploadModel.upload_type === 'campaign_image' )
                {
                    uploadModel.file_url(response.body.campaign_image[0].campaign_image);
                    fileUploader.cancelAll();
                    addNotification( 'Campaign image uploaded', 'success' );

                    const dashboard = fileUploader.getPlugin('Dashboard')
                    
                    if ( dashboard.isModalOpen() )
                        dashboard.closeModal();
                }
            }
        });

        // Fired when all uploads are complete.
        fileUploader.on('complete', (result) => {
            uploadModel.upload_status('upload-complete');

            if( result.successful.length > 0 ) 
            {
                addNotification( 'File uploaded', 'success' );

                // Get filename without extension
                let file_extension = path.extname(result.successful[0].meta.filename_orig);
                let basename = path.basename(result.successful[0].meta.filename_orig, file_extension);

                if( uploadModel.upload_type === 'asset_video' )
                    uploadModel.entity_name(basename);

                if( uploadModel.upload_type === 'mix_audio' )
                    uploadModel.entity_name(basename);

                if( uploadModel.upload_type === 'mix_video' )
                    uploadModel.entity_name(basename);
            }
        });

        fileUploader.on('error', (error) => {
            console.error('error', error);
            uploadModel.upload_status('error');
            addNotification( 'Error: ' + error.message, 'error' );
        });

        fileUploader.on('upload-error', (file, error) => {
            console.log('error with file:', file.id);
            console.log('error message:', error);
            uploadModel.upload_status('error');
            addNotification( 'Upload error', 'error' );
        });

        fileUploader.on('back-online', () => {
            fileUploader.retryAll()
        });

        document.addEventListener("uploader.pauseUpload", (evt) => {
            if( uploadModel.constructor.name === 'UploadArea' )
            {
                if( uploadModel.uuid() !== undefined && uploadModel.uuid() === evt.detail.uuid ) 
                    fileUploader.pauseAll();
            }
        });

        document.addEventListener("uploader.resumeUpload", (evt) => {
            if( uploadModel.constructor.name === 'UploadArea' )
            {
                if( uploadModel.uuid() !== undefined && uploadModel.uuid() === evt.detail.uuid ) 
                    fileUploader.resumeAll();
            }
        });

        document.addEventListener("uploader.stopUpload", (evt) => {
            fileUploader.cancelAll();
        });
    }
};